// extracted by mini-css-extract-plugin
export var button = "_7z-7";
export var buttonRow = "_7z-6";
export var fadeIn = "_7z-1";
export var gradient = "_7z-0";
export var panel = "_7z-2";
export var panelIn = "_7z-3";
export var subtitle = "_7z-5";
export var title = "_7z-4";